/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetChosenNameInternalRequest} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/set_chosen_name_internal.pb'
import {SetChosenNameInternalResponse} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/set_chosen_name_internal.pb'


export const setChosenNameInternal = (request: SetChosenNameInternalRequest, options?: CashRequestOptions) => post<SetChosenNameInternalRequest, SetChosenNameInternalResponse>("/2.0/cash/set-chosen-name-internal", request, {...options, rejectOnError: true })